import React from "react"
import errorpageImg from "../../images/error-page-img.png"
import "./ErrorPage.css"

function ErrorPage() {
  return (
    <>
      {" "}
      <div className="errorpage-wrapper">
        <div className="errorBoxCard">
          <h1 >404</h1>
          <img
            src={errorpageImg}
            className="img-fluid"
            title="errorImg"
            alt="errorImg"
            width="200"
            height="150"
          />
          <h2 >Something Went Wrong !</h2>

          <p>Page Not Found</p>
          <button className="view-profile">Go To Home</button>
        </div>
      </div>
    </>
  )
}

export default ErrorPage